import { createFileRoute } from '@tanstack/react-router'
import { DocumentFieldManagementPage } from '@/pages/document-field-management/document-field-management-page'

export const Route = createFileRoute(
  '/document-collection_/$id/document-fields',
)({
  component: DocumentFields,
})

function DocumentFields() {
  const { id } = Route.useParams()

  return <DocumentFieldManagementPage id={id} />
}
